import * as z from "zod";
import {
  onboardingV2OverviewProductScopeSchema,
  onboardingV2ReturnsRevenueModeSchema,
} from "./analytics-product-id";

const timePeriodSchema = z.enum([
  "day",
  "week",
  "month",
  "last-month",
  "quarter",
  "all",
  "custom",
]);

const customRangeSchema = z.object({
  start: z.string().min(1),
  end: z.string().min(1),
});

const statusFilterSchema = z.enum([
  "Completed",
  "Reopened",
  "Awaiting approval",
  "In progress",
  "Partial Completion",
  "Help Requested",
]);

const numericFilterSchema = z.object({
  operator: z.enum(["lt", "gt"]),
  value: z.number().min(0),
});

const dateRangeFilterSchema = z.object({
  start: z.string().min(1),
  end: z.string().min(1),
});

export const onboardingV2OverviewAnalyticsInputSchema = z
  .object({
    timePeriod: timePeriodSchema,
    customRange: customRangeSchema.optional(),
    productScope: onboardingV2OverviewProductScopeSchema.default("all"),
    returnsRevenueMode:
      onboardingV2ReturnsRevenueModeSchema.default("weighted"),
    hideArchived: z.boolean().default(true),
    statuses: z.array(statusFilterSchema).optional(),
    startDateRange: dateRangeFilterSchema.optional(),
    durationFilter: numericFilterSchema.optional(),
    dealSizeFilter: numericFilterSchema.optional(),
    filterLowIntent: z.boolean().optional(),
  })
  .superRefine((value, ctx) => {
    if (value.timePeriod === "custom" && !value.customRange) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "customRange is required when timePeriod is custom",
        path: ["customRange"],
      });
    }
  });

export type OnboardingV2OverviewAnalyticsInput = z.infer<
  typeof onboardingV2OverviewAnalyticsInputSchema
>;
